import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '../../../../constants/routes';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import SectionBodyGrid from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBodyGrid/SectionBodyGrid';
import './sleepTerritoryPage.scss';

const SleepTerritoryPage: React.FC = () => {
    useEffect(() => {
        const items = Array.from(document.querySelectorAll<HTMLElement>('.sleepTerritoryPage [data-animate]'));
        const root = document.querySelector<HTMLElement>('.sleepTerritoryPage');
        const heroWrap = document.querySelector<HTMLElement>('.sleepTerritoryPage__heroWrap');
        const hero = document.querySelector<HTMLElement>('.sleepTerritoryPage__hero');
        if ('IntersectionObserver' in window) {
            const revealObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            (entry.target as HTMLElement).classList.add('is-visible');
                            revealObserver.unobserve(entry.target);
                        }
                    });
                },
                { root: null, threshold: 0.15, rootMargin: '0px 0px -10% 0px' },
            );
            items.forEach((el) => revealObserver.observe(el));
        } else {
            items.forEach((el) => el.classList.add('is-visible'));
        }
        let raf = 0;
        const updateHeroProgress = () => {
            if (!heroWrap || !hero) return;
            const rect = heroWrap.getBoundingClientRect();
            const vh = window.innerHeight || 1;
            const scrolled = Math.max(0, -rect.top);
            const fadeDistance = Math.min(vh * 0.4, Math.max(1, rect.height)); // 40% экрана, не больше высоты wrapper
            const progress = Math.max(0, Math.min(1, scrolled / fadeDistance));
            hero.style.setProperty('--heroProgress', String(progress));
            root?.style.setProperty('--heroProgress', String(progress));
            raf = 0;
        };

        const onScrollOrResize = () => {
            if (raf) return;
            raf = requestAnimationFrame(updateHeroProgress);
        };

        window.addEventListener('scroll', onScrollOrResize, { passive: true });
        window.addEventListener('resize', onScrollOrResize);
        updateHeroProgress();

        return () => {
            window.removeEventListener('scroll', onScrollOrResize);
            window.removeEventListener('resize', onScrollOrResize);
            if (raf) cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div className="sleepTerritoryPage">
            <Header />
            <div className="sleepTerritoryPage_headerWrapper">
                <SectionHeader title="Территория Cна" />
            </div>
            <SectionBody>
                <SectionBodyGrid>
                    <>
                        <section className="sleepTerritoryPage__heroWrap" aria-label="Вступительный экран">
                            <div className="sleepTerritoryPage__hero">
                                <img className="sleepTerritoryPage__bg" src="/sleep-territory/01.jpg" alt="" aria-hidden="true" decoding="async" loading="eager" />
                                <div className="sleepTerritoryPage__overlay" />
                                <div className="sleepTerritoryPage__copy">
                                    <p>Погрузитесь в мир комфортного отдыха и приятных сновидений с коллекцией "Территория сна" от торгового дома С. Габай.</p>
                                </div>
                            </div>
                        </section>
                        <div className="sleepTerritoryPage__cta" data-animate="rise">
                            <Link className="sleepTerritoryPage__link" to={PATHS.showcase}>
                                Перейти в каталог
                                <img className="sleepTerritoryPage__link_img" src="/icons/arrow-up-right.svg" alt="С. Габай — логотип" />
                            </Link>
                        </div>
                        <section className="sleepTerritoryPage__stage" aria-label="Описание и визуал коллекции">
                            <article className="sleepTerritoryPage__text" data-animate="rise">
                                <p>В коллекции представлены одеяла, подушки и аксессуары из натурального 100% шелка премиум-класса. </p>
                                <p>Разнообразие ассортимента открывает возможности для идеального выбора. </p>
                                <p>
                                    Любители лаконичного дизайна оценят изделия из шелка Тусса, ценители классических решений выберут шелк Малбери, а для самых
                                    искушенных подойдут одеяла из редчайшего в мире благородного золотого шелка Голд.
                                </p>
                                <p>Каждое изделие бережно изготовлено вручную при строгом соблюдении стандартов качества. </p>
                                <p>
                                    В интернет-магазине С. Габай можно купить одеяла из шелка различных размеров: 150х200 см, 200х230 см, 220х240 см и разной
                                    сезонности: летнее, весеннее, зимнее и всесезонное.
                                </p>
                                <p>В ассортименте также представлены подушки из премиального шелка Малбери в нежном хлопковом чехле.</p>
                                <p>
                                    Шелковые аксессуары для сна, дополняющие коллекцию, внесут финальный акцент в создании неповторимой атмосферы легкости и
                                    полноценного отдыха после насыщенного дня.
                                </p>
                            </article>
                            <figure className="sleepTerritoryPage__photo" data-animate="from-right">
                                <img className="sleepTerritoryPage__photoImg" src="/sleep-territory/02.jpg" alt="Иллюстрация 2" decoding="async" loading="lazy" />
                            </figure>
                        </section>
                    </>
                </SectionBodyGrid>
            </SectionBody>
            <Footer />
        </div>
    );
};

export default SleepTerritoryPage;
